import { operation } from 'src/app/queries/queries.js'

export const getOperationPlan = (slug, success) => ({
  type: 'API:OPERATION:PLAN',
  API: true,
  url: '/api/query',
  method: 'POST',
  data: {
    query: operation.operationPlan,
    variables: {
      slug
    }
  },
  success
})
